<template>
  <div>
    <div class="no-result" v-if="materialCount == 0">
      <img src="../assets/img/no_result.png" alt="" />
      <p>没有匹配到相关内容，换个搜索词试试吧~</p>
    </div>
    <div v-else>
      <div
        class="main container ad-master-container"
        v-if="admasterArr.length > 0"
      >
        <div class="meta">
          <div class="meta-num">
            搜索到 <span>{{ admasterArr.length }}</span
            >个和<span>{{ kw }}</span> 相关的广告主
            <span v-if="!!updateTime">更新时间：{{ updateTime }}</span>
          </div>
        </div>
        <div class="ad-master-box">
          <a @click="prev" class="btn prev-btn"
            ><i class="el-icon-arrow-left"></i
          ></a>
          <el-carousel
            trigger="click"
            height="100px"
            :loop="false"
            :autoplay="false"
            indicator-position="none"
            arrow="never"
            ref="carousel"
          >
            <el-carousel-item v-for="item in admasterPages" :key="item">
              <div class="ad-master-inner">
                <el-row :gutter="20">
                  <el-col
                    :span="6"
                    v-for="ad in admasterArr.slice(
                      (item - 1) * 4,
                      (item - 1) * 4 + 4
                    )"
                    :key="ad.title"
                    ><div class="ad-master" @click="gotoMaster(ad)">
                      <div class="icon">
                        <img v-if="!!ad.logo" :src="ad.logo" alt="" />
                        <span v-else class="ad-logo-text">{{
                          ad.title.split("").length > 0
                            ? ad.title.split("")[0]
                            : ""
                        }}</span>
                      </div>
                      <div>
                        <div class="title">{{ ad.title }}</div>
                        <div class="desc" :title="ad.company">
                          {{ !!ad.company ? ad.company : "..." }}
                        </div>
                      </div>
                    </div></el-col
                  >
                </el-row>
              </div>
            </el-carousel-item>
          </el-carousel>
          <a @click="next" class="btn next-btn"
            ><i si class="el-icon-arrow-right"></i
          ></a>
        </div>
      </div>
      <div class="main container">
        <div class="meta">
          <div class="meta-num">
            搜索到 <span>{{ materialCount }}</span
            >个和<span>{{ kw }}</span
            >相关的广告素材
            <span v-if="!!updateTime">更新时间：{{ updateTime }}</span>
          </div>
        </div>
        <div class="filter">
          <div>
            <!-- <el-select
          class="filter-adslot"
          v-model="adslot"
          placeholder="请选择"
          size="mini"
          @change="search"
        >
          <el-option key="" label="广告位" value=""></el-option>
          <el-option
            v-for="item in adslotArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
            <el-select
              class="filter-platform"
              v-model="platform"
              placeholder="请选择"
              size="mini"
              @change="search"
            >
              <el-option key="" label="渠道" value=""></el-option>
              <el-option
                v-for="item in platformArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <!-- <el-select
          class="filter-style"
          v-model="materialType"
          placeholder="请选择"
          size="mini"
          @change="search"
        >
          <el-option key="" label="素材样式" value=""></el-option>
          <el-option
            v-for="item in materialTypeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
            <el-select
              class="filter-system"
              v-model="system"
              placeholder="请选择"
              size="mini"
              @change="search"
            >
              <el-option key="" label="设备类型" value=""></el-option>
              <el-option
                v-for="item in systemArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>

          <div class="sort">
            <label>排序方式</label>
            <el-select
              v-model="order"
              placeholder="请选择"
              size="mini"
              @change="changeOrder"
            >
              <el-option
                v-for="item in orderArr"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="list">
          <MaterialItem
            v-for="item in materialArr"
            :material="item"
            :key="item.id"
          ></MaterialItem>
        </div>
      </div>
      <div class="pager">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="24"
          layout="prev, pager, next, jumper"
          :total="totalPage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import MaterialItem from "../components/MaterialItem";
export default {
  name: "SearchResult",
  components: { MaterialItem: MaterialItem },
  mounted() {
    let session = this.$route.query["session"];
    if (!!session) {
      sessionStorage.setItem("session", session);
      sessionStorage.setItem("isLogin", "1");
    }

    this.kw = this.$route.query["kw"];

    let now = moment();
    let start = now.format("YYYY-MM-DD");
    let end = now.add(-30, "days");
    end = end.format("YYYY-MM-DD");
    this.daterange = [end, start];

    this.querySerchConfig();
    this.search();
    this.searchAdmaster();

    window.addEventListener("keypress", this.enterSearch);
    this.$eventBus.$on("searchMsg", (searchText) => {
      console.log("监听search事件：", searchText);
      this.kw = searchText;
      this.search();
      this.searchAdmaster();
    });
  },

  data() {
    return {
      kw: "",
      admasterArr: [],
      showAdmaster: true,
      admasterPages: 0,
      duration: "30",
      daterange: [],
      materialType: "", // 素材类型：优质素材或活跃素材
      materialCount: 0,
      updateTime: "",
      materialArr: [],
      currentPage: 1,
      currentAdmasterPage: 1,
      totalPage: 10,
      subType: "",
      industryArr: [],
      platform: "",
      platformArr: [
        {
          label: "广点通",
          value: "gdt",
        },
        {
          label: "头条",
          value: "toutiao",
        },
      ],
      cat: "",
      subCat: "",
      subCatArr: [],

      system: "",
      systemArr: [
        {
          label: "安卓",
          value: "Android",
        },
        {
          label: "iOS",
          value: "iOS",
        },
      ],
      adslot: "",
      adslotArr: [
        {
          label: "开屏",
          value: "1",
        },
        {
          label: "banner",
          value: "2",
        },
        {
          label: "信息流",
          value: "3",
        },
      ],
      materialType: "",
      materialTypeArr: [
        {
          label: "图片",
          value: "Android",
        },
        {
          label: "视频",
          value: "iOS",
        },
      ],
      order: "",
      orderArr: [
        {
          label: "默认",
          value: "",
        },
        {
          label: "最后展示时间",
          value: "edTime",
        },
        {
          label: "首次展示时间",
          value: "stTime",
        },
        {
          label: "展示数",
          value: "showNum",
        },
        {
          label: "投放天数",
          value: "showDayNum",
        },
        {
          label: "点击率",
          value: "clickRate",
        },
      ],
    };
  },
  methods: {
    search() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let data = {
        page: this.currentPage,
        cnt: 24,
        keyword: this.kw,
        options: {
          orderBy: this.order,
          system: this.system,
          platform: this.platform,
        },
      };
      console.log(data);
      this.$http
        .post("/fireeye/material/search", data)
        .then((res) => {
          let data = res.data;
          if (data.code != 0) {
            data = data.data;
            this.materialArr = data.list;
            this.materialCount = data.all;
            this.totalPage = parseInt(data.all);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
    gotoMaster(ad) {
      this.$router.push({
        path: "/admaster-detail?name=音跃球球&start=1603382400&end=1621785600",
        query: {
          name: ad.title,
        },
      });
    },
    searchAdmaster() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      let data = {
        page: this.currentAdmasterPage,
        cnt: 8,
        keyword: this.kw,
        options: {
          orderBy: this.order,
        },
      };
      console.log(data);
      this.$http
        .post("/fireeye/advertiser/search/keyword?keyword=" + this.kw, data)
        .then(
          (res) => {
            let data = res.data;
            if (data.code != 0) {
              data = data.data;
              this.admasterArr = data;
              this.admasterPages = Math.ceil(data.length / 4);
              this.admasterTotal = data.length;
            } else {
              this.showAdmaster = false;
            }
          },
          () => {
            this.showAdmaster = false;
          }
        )
        .finally(() => {
          loading.close();
        });
    },
    prev() {
      this.$refs.carousel.prev();
    },
    next() {
      this.$refs.carousel.next();
    },
    handleSizeChange() {},
    handleCurrentChange() {
      this.search();
    },
    querySerchConfig() {
      this.$http.get("/fireeye/material/search/config").then((res) => {
        let data = res.data;
        this.industryArr = data.data.industrys;
      });
    },
    changeCat(cat) {
      this.$set(this, "subCat", "");
      if (cat == "") {
        this.currentPage = 1;
        this.search();
        return;
      }
      for (let item of this.industryArr) {
        if (item.name == cat) {
          this.subCatArr = item.tags;
          this.currentPage = 1;
          this.search();
        }
      }
    },
    changeSubCat() {
      this.currentPage = 1;
      this.search();
    },
    changeOrder() {
      this.currentPage = 1;
      this.search();
    },
    changeDateRange() {
      console.log(this.daterange, this.duration);
      if (this.daterange.length == 2) {
        let start = this.daterange[0];
        let end = this.daterange[1];
        let gap = 0 + end.replaceAll("-", "") - start.replaceAll("-", "");
        console.log(end.replaceAll("-", ""), start.replaceAll("-", ""), gap);
        this.duration = 0;
      }
      this.currentPage = 1;
      this.search();
    },
    changeDate() {
      console.log(this.daterange, this.duration);
      let now = moment();
      console.log(now);
      let start = now.format("YYYY-MM-DD");
      console.log(start);
      let end = now.add(-this.duration, "days");
      end = end.format("YYYY-MM-DD");
      this.daterange = [end, start];
      this.currentPage = 1;
      this.search();
    },
    clickRadio(value) {
      console.log(value, this.materialType);
      if (value == this.materialType) {
        this.materialType = "";
      } else {
        this.materialType = value;
      }
      this.currentPage = 1;
      this.search();
    },
  },
};
</script>

<style lang="less" scoped>
.no-result {
  text-align: center;
  margin-top: 140px;
  img {
    width: 240px;
    height: 160px;
  }
  p {
    margin-top: 50px;
  }
}
.main {
  margin-top: 36px;

  .meta {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    height: 60px;
    line-height: 60px;
    .meta-num {
      span {
        font-weight: 600;
        font-size: 16px;
        padding: 0 5px;
        color: #409eff;
      }
    }
    .sort {
      label {
        padding-right: 20px;
      }
      .el-select {
        display: inline-block;
      }
    }
  }

  .filter {
    display: flex;
    justify-content: space-between;
    margin: 10px 0 20px;
    .filter-adslot {
      width: 100px;
      margin-right: 20px;
    }
    .filter-platform {
      width: 100px;
      margin-right: 20px;
    }
    .filter-style {
      width: 100px;
      margin-right: 20px;
    }
    .filter-system {
      width: 100px;
      margin-right: 20px;
    }
  }

  .list {
    margin-right: -15px;
    display: flex;
    flex-wrap: wrap;
  }
  .ad-master-box {
    position: relative;
    .btn {
      font-size: 30px;
      font-weight: 600;
      cursor: pointer;
    }
    .prev-btn {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      line-height: 100px;
    }
    .next-btn {
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
      line-height: 100px;
    }

    .el-carousel {
      margin: 0 40px;
    }
    .ad-master-inner {
      padding: 10px 0;
    }
    .ad-master {
      display: flex;
      box-sizing: border-box;
      padding: 14px;
      border: 1px solid #ddd;
      box-shadow: 10px 10px 5px #999;
      cursor: pointer;

      img,
      .ad-logo-text {
        display: block;
        width: 40px;
        height: 40px;
        margin-right: 16px;
      }
      .ad-logo-text {
        text-align: center;
        line-height: 40px;
        border: 1px solid #ddd;
        border-radius: 20px;
        font-weight: 600;
      }
      .title {
        font-size: 14px;
      }
      .desc {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        word-break: break-all;
        margin-top: 5px;
      }
    }
  }
}
.ad-master-container {
  box-sizing: border-box;
  padding: 20px 10px;
  margin-top: 0;
}
.pager {
  margin: 30px 0 60px;
}
</style>